import { readCookie } from 'teld-web-component/lib/method'

const setIconItem = ($favicon, image) => {
  $favicon.type = 'image/x-icon'
  $favicon.rel = 'shortcut icon'
  $favicon.href = image
  document.getElementsByTagName('head')[0].appendChild($favicon)
}
const setIcon = (image) => {
  const faviconList = document.querySelectorAll("link[rel*='icon']")
  if (faviconList.length === 0) {
    faviconList.push(document.createElement('link'))
  }
  for (let i = 0; i < faviconList.length; i++) {
    setIconItem(faviconList[i], image)
  }
}

const formatStandardTitle = (defaultTitle = '...') => {
  if (window.top === window.self) {
    if (readCookie('SAAS_X-Icon')) {
      setIcon(readCookie('SAAS_X-Icon'))
    } else {
      setIcon('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAIAAAB/6NG4AAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAB1JREFUKFNj/P//PwPRgAlKEwdGVWOCUdXogIEBAKSfAxnXDaqBAAAAAElFTkSuQmCC')
    }
    if (readCookie('SAAS_Title')) {
      document.title = readCookie('SAAS_Title')
    } else {
      document.title = defaultTitle
    }
  }
}

export {
  formatStandardTitle
}



// WEBPACK FOOTER //
// ./src/utils/standard.js